import { render } from "./view-user.vue?vue&type=template&id=8a456f0c&scoped=true"
import script from "./view-user.vue?vue&type=script&lang=js"
export * from "./view-user.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./view-user.vue?vue&type=style&index=1&id=8a456f0c&scoped=true&lang=css"

import exportComponent from "D:\\MY PROJECTS\\Vue 3 Project\\MarriageBeauroAdmin\\marriage_beauro_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a456f0c"]])

export default __exports__